// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__5uhIt","header":"styles_header__40pPY","body":"styles_body__Z7kas","image":"styles_image__18or2"};